import {
  ALLOW_CHANGE_PASSWORD,
  AUTH_LOGIN,
  AUTH_LOGOUT,
  EVENT_MATCHES_EDIT_MODAL_HIDE,
  EVENT_MATCHES_EDIT_MODAL_SHOW,
  FLEET_LOADED,
  SET_FLEET_OVERRIDE,
} from '../../constants/action-types';
import { StoreState } from '../../interfaces';
import { initialStoreState } from './storeState';

export const storeReducer = (state: StoreState = initialStoreState, action: any): StoreState => {
  switch (action.type) {
    // ------ Modal Window Actions

    case EVENT_MATCHES_EDIT_MODAL_SHOW:
      return { ...state, editMatchesEventObject: action.event };

    case EVENT_MATCHES_EDIT_MODAL_HIDE:
      return { ...state, editMatchesEventObject: null };

    // ------- Auth Filters ------------------------------
    case AUTH_LOGIN:
      return { ...state, isAuthenticated: action.isAuthenticated };

    case ALLOW_CHANGE_PASSWORD:
      return { ...state, allowChangePassword: true };

    case AUTH_LOGOUT:
      return { ...state, isAuthenticated: false };

    case FLEET_LOADED:
      return { ...state, fleet: action.fleet };

    case SET_FLEET_OVERRIDE:
      return { ...state, currentSelectedFleetID: action.fleetID };

    default:
      return state;
  }
};
